import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../services/axois";
import { formatDateToUTC } from "../../../utility/genricFunction";
// this is for demo purpose only / change for further api calls


export const getFacultyMonthBilling = createAsyncThunk(
  "facultyMonthBilling/getMonthBilling",
  async ({facultyId,month,year}) => {
    try {
      let url = `/faculty/${facultyId}/month-wise-billing/?month=${encodeURIComponent(month)}&year=${encodeURIComponent(year)}`;
      const response = await apiClient.get(url);
      response?.data?.result?.timetable?.forEach(faculty => {
        const date = faculty.date !== null && new Date(faculty.date);
        faculty.date = faculty.date !== null && formatDateToUTC(date)
      });   
      return response?.data?.result; // todo: need to store only "result" array inside redux state
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);

export const FacultyMonthBillPaid = createAsyncThunk(
  "facultyMonthBilling/FacultyMonthBillPaid",
  async (data,{ dispatch }) => {
    try {

      const facultyBillingData = {
        amount: data.facultyMonthlyPayment,
        billingDate: data.todayDate,
        isPaid: true,
        month:String(data.month), 
        year:String(data.year)
      }

      const facultyId = data.facultyId
      let url = `/faculty/${facultyId}/billing-info`;
      await apiClient.post(url, facultyBillingData);
      dispatch(getFacultyMonthBilling({ facultyId, month:data.month, year:data.year }))
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);





